module.exports = __webpack_public_path__ + "fonts/Graphik-ThinItalic.681d1e04.woff";